import React from 'react';

import { Badge } from '@olxbr/ds-web';

import { isMobile } from '../../../../../core/components/mobile-apps/service/mobile';
import PLANS_FUNCIONALITIES from './constants';
import {
  Wrapper,
  Title,
  Subtitle,
  DescriptionItemContainer,
  ImageContainer,
  DescriptionTitle,
  ContentContainer,
  TagContainer,
  ContentTitle,
  Container,
} from './styles';

function DescriptionPlans() {
  function renderContentTitle(title) {
    if (!title) return null;

    return <ContentTitle>{title}</ContentTitle>;
  }

  function renderContentSubtitle(subtitle) {
    if (typeof subtitle === 'string') {
      return <Subtitle>{subtitle}</Subtitle>;
    }
    return subtitle;
  }

  function renderContentTag(tag) {
    if (!tag) return null;

    return (
      <TagContainer>
        <Badge color="secondary" aria-label="string">{tag}</Badge>
      </TagContainer>
    );
  }

  function renderContent(content) {
    return content.map(({
      title, subtitle, id, tag = null,
    }) => (
      <ContentContainer key={id} flexDirection="column">
        {renderContentTag(tag)}
        {renderContentTitle(title)}
        {renderContentSubtitle(subtitle)}
      </ContentContainer>
    ));
  }

  return (
    <Container flexDirection="column">
      <Title>Entenda melhor as ferramentas para acelerar o seu negócio</Title>
      {
        PLANS_FUNCIONALITIES.map(({
         title, id, imageUrl, flexDirection, content,
        }) => (
          <DescriptionItemContainer
            flexDirection={flexDirection(isMobile)}
            justifyContent="space-between"
            alignItems="center"
            key={id}
          >
            <Wrapper flexDirection="column">
              <DescriptionTitle>{title}</DescriptionTitle>
              {renderContent(content)}
            </Wrapper>
            <ImageContainer>
              <img src={imageUrl} alt={title} height="100%" width="100%" />
            </ImageContainer>
          </DescriptionItemContainer>
        ))
      }
    </Container>
  );
}

export default DescriptionPlans;
